/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries.
 */

require('./bootstrap');
require('./mobile-menu');
require('./hover-cards');
require('./video-modal-listener');

//import objectFitImages from 'object-fit-images';
//objectFitImages();
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page via #theme. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
window.addEventListener('load', function () {
    const theme = new Vue({
        el: '#theme',

        data() {
            return {
                //
            }
        },

        /**
         * The component has been created by Vue.
         */
        created() {
            var self = this;
        },

        mounted() {
            this.whenReady();
            $(document).trigger('vue-loaded');
        },

        methods: {
            /**
             * Finish bootstrapping the application.
             */
            whenReady() {
                //
            },
        },
    });
});